import { getDefaultMargin, getDefaultMarginOverlay, getDefaultWidthOverlay } from '../utils'

export const SectionDesignSettings = {
  'section-design-shape': {
    phone: 'none',
    'phone-landscape': 'none',
    tablet: 'none',
    'tablet-landscape': 'none',
    desktop: 'none',
    tv: 'none',
  },
  'section-design-width': {
    phone: ['100'],
    'phone-landscape': ['100'],
    tablet: ['100'],
    'tablet-landscape': ['100'],
    desktop: ['100'],
    tv: ['100'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'section-design-width-preset': {
    phone: '100',
    'phone-landscape': '100',
    tablet: '100',
    'tablet-landscape': '100',
    desktop: '100',
    tv: '100',
  },
  'section-design-height': {
    phone: [400],
    'phone-landscape': [400],
    tablet: [400],
    'tablet-landscape': [400],
    desktop: [400],
    tv: [400],
  },
  'section-design-height-mode': {
    phone: 'auto',
    'phone-landscape': 'auto',
    tablet: 'auto',
    'tablet-landscape': 'auto',
    desktop: 'auto',
    tv: 'auto',
  },
  // Layout column
  'section-design-layout': {
    phone: [12],
    'phone-landscape': [12],
    tablet: [12],
    'tablet-landscape': [12],
    desktop: [12],
    tv: [12],
  },
  'section-design-orientation': {
    phone: 'vertical',
    'phone-landscape': 'vertical',
    tablet: 'vertical',
    'tablet-landscape': 'vertical',
    desktop: 'vertical',
    tv: 'vertical',
  },
  // 'section-design-max-items': {
  //   phone: 1,
  //   'phone-landscape': 2,
  //   tablet: 1,
  //   'tablet-landscape': 3,
  //   desktop: 4,
  //   tv: 4,
  // },
  'section-design-same-height': {
    phone: false,
    'phone-landscape': false,
    tablet: false,
    'tablet-landscape': false,
    desktop: false,
    tv: false,
  },
  'section-design-h-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'section-design-horizontal-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'section-design-reverse-order': {
    phone: false,
    'phone-landscape': false,
    tablet: false,
    'tablet-landscape': false,
    desktop: false,
    tv: false,
  },
  'section-design-v-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'section-design-padding': {
    phone: getDefaultMargin([20]),
    'phone-landscape': getDefaultMargin([20]),
    tablet: getDefaultMargin([20]),
    'tablet-landscape': getDefaultMargin([20]),
    desktop: getDefaultMargin([20]),
    tv: getDefaultMargin([20]),
  },
  'section-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  'section-design-gap': {
    phone: { value: 10, unit: 'px' },
    'phone-landscape': { value: 10, unit: 'px' },
    tablet: { value: 10, unit: 'px' },
    'tablet-landscape': { value: 10, unit: 'px' },
    desktop: { value: 10, unit: 'px' },
    tv: { value: 10, unit: 'px' },
  },
  // variant
  'section-design-variant': {
    phone: 'normal',
    'phone-landscape': 'normal',
    tablet: 'normal',
    'tablet-landscape': 'normal',
    desktop: 'normal',
    tv: 'normal',
  },
  'section-design-sticky-position': {
    phone: 'top',
    'phone-landscape': 'top',
    tablet: 'top',
    'tablet-landscape': 'top',
    desktop: 'top',
    tv: 'top',
  },
  'section-design-sticky-offset': {
    phone: 0,
    'phone-landscape': 0,
    tablet: 0,
    'tablet-landscape': 0,
    desktop: 0,
    tv: 0,
  },
}
